import React, {useState} from 'react'

import BasePage from "../../Components/BasePage/BasePage";

import './AjoutCartePage.scss'
import BaseButton from "../../Components/BaseButton/BaseButton";
import {useDispatch, useSelector} from "react-redux";
import {StateModel} from "../../Models/StateModel";
import {OrderModel} from "../../Models/OrderModel";
import {UserModel} from "../../Models/UserModel";
import {CardCvcElement, CardExpiryElement, CardNumberElement, useElements, useStripe} from "@stripe/react-stripe-js";
import {StripeCardNumberElement} from "@stripe/stripe-js";
import {usePaymentWithCard} from "../../hooks/usePaymentWithCard";
import {usePostOrder} from "../../hooks/usePostOrder";
import {CarteBancaireRequestModel} from "../../Models/request/CarteBancaireRequestModel";
import {setPanier, setSelectedCard, setTimeCreationPanier, setUser} from "../../store/actions";
import axios from "axios";
import {useNavigate} from "react-router-dom";
import Success from "../../Components/Success/Success";
import check from "../../Assets/Icons/check.svg";
import {useLoader} from "../../hooks/useLoader";
import Loader from "../../Components/Loader/Loader";
import {useError} from "../../hooks/useError";
import Error from "../../Components/Error/Error";
import {SendOrderMailRequest} from "../../Models/request/SendOrderMail";
import {OrderResponseModel} from "../../Models/OrderResponseModel";
import {StadiumModel} from "../../Models/StadiumModel";
import {useCardTypeAccepted} from "../../hooks/useCardTypeAccepted";
import {AcceptedCardResponseModel} from "../../Models/AcceptedCardResponseModel";
import {useTranslation} from "react-i18next";
import {mapApiError} from "../../i18n/mapApiError";
import {getCurrentLanguage} from "../../i18n/i18n";

let paymentId: string | undefined = undefined
let cb: any = undefined
const AjoutCartePage: React.FC = ({}) => {
    const {t} = useTranslation(['ajoutCarte', 'common'])
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const stripe = useStripe();
    const elements = useElements();

    const panier = useSelector<StateModel, OrderModel | undefined>(state => state.panier)
    const user = useSelector<StateModel, UserModel | undefined>(state => state.user)
    const stade = useSelector<StateModel, StadiumModel | undefined>(state => state.stadium)

    const [showBtmSheet, setShowBtmSheet] = useState<boolean>(false)
    const payWithCard = usePaymentWithCard()
    const loader = useLoader()
    const postOrder = usePostOrder(loader.show, loader.hide)
    const error = useError()
    const cardTypeAccepted = useCardTypeAccepted()

    const handleSubmit = async (event?: any) => {
        event?.preventDefault();

        if (!stripe || !elements) {
            return;
        }
        loader.show()
        const cardNumberElement: StripeCardNumberElement = elements.getElement(CardNumberElement) as StripeCardNumberElement;

        const result = await stripe.createPaymentMethod({
            type: 'card',
            card: cardNumberElement
        });


        if(result.error) {
            loader.hide()
            error.open(result.error.message || '')
        } else if (user?.id) {
            processSaveCard(result.paymentMethod.id)
        } else {
            cardTypeAccepted(result.paymentMethod.card?.brand)
                .then((res: AcceptedCardResponseModel) => {
                    if (!res.isAccepted) {
                        loader.hide()
                        error.open(mapApiError(res.message))
                    } else {
                        cb = result.paymentMethod.card
                        processPayment(result.paymentMethod.id)
                    }
                })
                .catch(() => {
                    cb = result.paymentMethod.card
                    processPayment(result.paymentMethod.id)
                })

        }
    };

    const processPayment = (cardId: string) => {
        if(panier) {
            const body = {
                id: `${stade?.reference}${panier.reference}`,
                amount: panier.totalPriceTTC ? +panier.totalPriceTTC * 100 : 0,
                cardId,
                description: `${stade?.reference} commande #${panier.reference} ${user?.email}`,
                country: "FR",
                ht: panier.totalPriceHT ? +panier.totalPriceHT * 100 : 0,
            }
            payWithCard(
                body,
                (id) => {
                    paymentId = id
                    loader.hide()
                    setShowBtmSheet(true)
                },
                (message) => {
                    error.open(message.includes("card_declined") ? t('ajoutCarte:errors.cardDeclined') : t('common:errors.tryAgainLater'))
                    loader.hide()
                }
            )
        }
    }

    const processSaveCard = (cardId: string) => {
        if (user?.stripeId) {
            saveCard(cardId, user.stripeId)
        } else {
            axios
                .post(`${process.env.REACT_APP_BART_URL}/stripe/create-customer?id=${user?.id}`)
                .then((res: any) => {
                    const stripeId = res.data
                    saveCard(cardId, stripeId)
                })
                .catch(() => {
                    error.open(t('common:errors.tryAgainLater'))
                    loader.hide()
                });
        }
    }

    const saveCard = (token: string, customerId: string) => {
        if (user?.id) {
            const newCB: CarteBancaireRequestModel = {
                userId: user.id,
                userStripeId: customerId,
                token
            }

            axios.post(`${process.env.REACT_APP_BART_URL}/cartes-bancaires/create`, newCB)
                .then((res) => {
                    dispatch(setSelectedCard(res.data))
                    const newsCartesBancaires = user.cartesBancaires ? [...user.cartesBancaires] : []
                    newsCartesBancaires.push(res.data);
                    dispatch(setUser({...user, stripeId: customerId, cartesBancaires: newsCartesBancaires}))
                    setShowBtmSheet(true)
                })
                .catch(() => error.open(t('common:errors.tryAgainLater')))
                .finally(() => loader.hide())
        }
    };

    const formatPickup = (pickup?: string) => {
        if(pickup) {
            const splited = pickup.split(" ")
            return splited[splited.length - 1]
        }
        return ''
    }

    const computeTvas = (orderProducts: any[]) => {
        const tvas: { rate: string, total: number }[] = []
        orderProducts.forEach((p) => {
            if (p.tvaRate && p.totalTva) {
                const existingTva = tvas.find(t => t.rate === p.tvaRate)
                if (existingTva) {
                    existingTva.total += p.totalTva
                } else {
                    tvas.push({rate: p.tvaRate, total: p.totalTva})
                }
            }
        })
        return tvas
    }

    const onPostOrder = () => {
        postOrder(
            (res: OrderResponseModel) => {
                const body: SendOrderMailRequest = {
                    date: new Date(),
                    total: res.totalPriceTTC ? +res.totalPriceTTC : 0 ,
                    totalHt: res.totalPriceHT ? +res.totalPriceHT : 0,
                    nomUser: user?.prenom || '',
                    pickupZone: formatPickup(res.pdv?.bartPickup?.name),
                    reference: res.reference,
                    payment: {brand: cb?.brand || '', last4: cb?.last4 || ''},
                    tvas: computeTvas(res.orderProducts ?? []),
                    items: res.orderProducts?.map((p: any) => {
                        return {
                            nom: p.name,
                            quantity: p.quantity,
                            total: p.totalPriceTTC,
                            tvaRate: p.tvaRate || 0,
                            totalTva: p.totalTva || 0
                        }
                    }) || []
                }
                void axios.post(`${process.env.REACT_APP_BART_URL}/emails/send_order_email/${user?.email}?lang=${getCurrentLanguage()}`, body)
                dispatch(setPanier(undefined))
                dispatch(setTimeCreationPanier(undefined))
                navigate('/qrCode', {
                    state: {
                        reference: res.reference,
                        pickup: res.pdv?.bartPickup?.name,
                        total: res.totalPriceTTC,
                        affluence: res.pdv?.affluence
                    }
                })
            },
            (err) => {
                void axios.delete(`${process.env.REACT_APP_BART_URL}/stripe/${paymentId}/refund`)
                setShowBtmSheet(false)
                error.open(mapApiError(err.response.data.errors[0].message))
            }
        )
    }

    return (
        <BasePage showBack title={t('ajoutCarte:title')}>
            {/* eslint-disable-next-line @typescript-eslint/no-misused-promises */}
            <form className="ajoutCarte" onSubmit={(e: any) => handleSubmit(e)}>
                <div className="ajoutCarte--input">
                    <p className="ajoutCarte--input--title">{t('ajoutCarte:cardNumberLabel')}</p>
                    <CardNumberElement />
                </div>
                <div className="ajoutCarte__duo">
                    <div className="ajoutCarte--input">
                        <p className="ajoutCarte--input--title">{t('ajoutCarte:expiryLabel')}</p>
                        <CardExpiryElement />
                    </div>
                    <div className="ajoutCarte--input">
                        <p className="ajoutCarte--input--title">{t('ajoutCarte:cvcLabel')}</p>
                        <CardCvcElement />
                    </div>
                </div>
            </form>
            <div className="ajoutCarteFooter">
                {/* eslint-disable-next-line @typescript-eslint/no-misused-promises */}
                <BaseButton disabled={loader.visible} onClick={() => handleSubmit()} text={user?.id ? t('ajoutCarte:addCard') : t('ajoutCarte:pay')} className="ajoutCarteFooter--btn"/>
            </div>
            <Success show={showBtmSheet}
                     close={() => user?.id ? navigate(-1) : onPostOrder()}
                     title={user?.id ? t('ajoutCarte:cardAdded') : t('ajoutCarte:paymentAccepted')}
                     icone={check}
            />
            <Error show={error.visible} close={error.close} title={t('common:errors.generic')} subTitle={error.message} />
            <Loader visible={loader.visible} />
        </BasePage>
    )
}

export default AjoutCartePage;
